import Scene from './classes/Scene';

document.addEventListener('DOMContentLoaded', () => {
  window.scene = new Scene();
});
